//#region Util Imports

import * as moment from 'moment'
import * as _ from 'underscore'

//#endregion

//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region DevExtreme Imports

import DataSource from 'devextreme/data/data_source'
import DevExpress from 'devextreme'

//#endregion

//#region IMR Imports

import { IMRToastHiddenArgs, IIMRToast } from '@imr/controls.angularjs/services/toast'

//#endregion

import { Api, LocalDictionaryFactory } from './../api/api.module'
import { GridRequestModel, ColumnModel } from '../api/api.models'

import { GetViewColumnOptions, OpView } from '../../models/core/op-view'
import { Enums } from '../../models/common/enums'

import { SystemService } from '../../services/system'

import { EventsNames } from '../../helpers/events-names'
import { CommonHelper, DataType } from '../../helpers/common-helper'
import { Permissions } from '../../helpers/permissions'
import { OperatorLayoutSettings } from '../../helpers/operator-layout-settings'
import { RequestManager } from '../../helpers/request-manager'
import { IUserSession } from '../../helpers/user-session'
import { ToastHelper } from '../../helpers/toast-helper'
import { LocalizationHelper } from '../../helpers'

import { ScopeBaseGrid } from '../common/common.base.grid.controller'
import { i18n } from '../common/i18n/common.i18n'
import { ActionSelectedFilters } from '../common/action-filters/action-filters.directive'
import { TreeListOptions } from '../common/tree-list/tree-list.controller'
import { GridOptions, GridTypes } from '../common/grid/grid.controller'
import { IMRBaseControlDirectiveController } from '../common/base'

interface ActionsScope extends ScopeBaseGrid {
    mainGridOptions: GridOptions
    mainTreeListOptions: TreeListOptions

    defaultColumns: ColumnModel[]
    columns: ColumnModel[]

    showGrid: boolean
    showArrow: boolean

    filtersInfoPopoverOptions: DevExpress.ui.dxPopoverOptions
    filtersInfoPopover: DevExpress.ui.dxPopover
}

export class ActionsController extends IMRBaseControlDirectiveController {
    pageSize: number = 2000
    permissions: any
    lastRequest: any
    treeList: any
    treeListId: number

    requestState: any = {}
    selectedFilters: ActionSelectedFilters = <ActionSelectedFilters>{}

    constructor(
        public $scope: ActionsScope,
        protected $state: StateService,
        protected $timeout: ng.ITimeoutService,
        protected $compile: ng.ICompileService,
        protected api: Api,
        private localDictionary: LocalDictionaryFactory,
        private $q: ng.IQService,
        private systemService: SystemService,
        protected userSession: IUserSession
    ) {
        super()

        jQuery.when.apply(jQuery,
            [Permissions.ACTION_EDIT, Permissions.ACTION_PARAMETERS_NOT_READONLY]
                .map(p => Permissions.hasPermissions([p]))
        ).then((...editPermission) => {
            var permissions = [false, editPermission, true, true]
            this.permissions = permissions
        })

        this.selectedFilters.selectedType = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionType, null)
        this.selectedFilters.selectedState = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionState, null)
        this.selectedFilters.selectedOperator = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionOperator, null)
        this.selectedFilters.selectedDevice = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionDeviceId, null)
        this.selectedFilters.selectedLocation = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionLocationId, null)
        this.selectedFilters.selectedMeter = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionMeterId, null)
        this.selectedFilters.selectedModule = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionModule, null)

        $scope.$root['dateFormatsDefer'].promise.then(() => {
            var dateFormat = window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')

            var date = new Date()
            date.setHours(0, 0, 0, 0)

            var fromDate = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionFromDate, null)
            if (!fromDate)
                this.selectedFilters.selectedFromDate = moment(date.setDate(date.getDate() - 6)).format(dateFormat)
            else
                this.selectedFilters.selectedFromDate = moment(fromDate, dateFormat).format(dateFormat)
            date = new Date()
            date.setHours(23, 59, 59, 999)

            var toDate = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ActionToDate, null)
            if (!toDate)
                this.selectedFilters.selectedToDate = moment(date).format(dateFormat)
            else
                this.selectedFilters.selectedToDate = moment(toDate, dateFormat).format(dateFormat)

            this.drawGrid()
        })

        $scope.$on(EventsNames.ACTION_DELETED, (event: ng.IAngularEvent, ...args: any[]) => {
            this.getActionsWithTreeListRefresh()
        })

        $scope.$on(EventsNames.FILTERS_UPDATED, (event, ...args) => {
            if (args)
                this.selectedFilters = args[0]
            else
                this.selectedFilters = <ActionSelectedFilters>{}

            this.getActionsWithTreeListRefresh()
        })

        $scope.$on(EventsNames.FILTERS_UPDATE_CANCEL, (event, ...args) => {
            if (this.requestState.request && !this.requestState.request.$resolved)
                RequestManager.cancelRequest(this.requestState)

            this.mockGetActionMethodAndRefreshGrid()
        })


        $scope.showDetails = (e) => {
            var array: any[] = this.treeList.getVisibleRows()
            var items = array.filter(item => item.data.parentId == e.data.parentId)
            var itemIds = items.map(item => item.data[CommonHelper.idField])

            this.systemService.openDetails({
                moduleName: Enums.SimaxModuleName.Action,
                referenceObjectId: e.data[CommonHelper.idField],
                pageItemsIds: itemIds
            })
        }


        $scope.$on(EventsNames.FILTERS_CLEARED, () => {
            this.selectedFilters = <ActionSelectedFilters>{}

            this.$state.params['ids'] = null

            this.resetDate()
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionType, null)
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionState, null)
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionOperator, null)
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionDeviceId, null)
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionLocationId, null)
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionMeterId, null)
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionModule, null)

            this.getActionsWithTreeListRefresh()

            $scope.$broadcast(EventsNames.FILTERS_CREARED_REDIRECT)
        })

        $scope.filtersInfoPopoverOptions = {
            onInitialized: e => {
                $scope.filtersInfoPopover = e.component
            },
            position: 'left',
            maxHeight: 60,
            width: 300,
            animation: {
                hide: {
                    type: 'fadeOut'
                },
                show: {
                    type: 'fadeIn'
                }
            }
        }
    }

    addValueToWhereClause(actionView: OpView, whereClause: string, type: number, value: any) {
        var columnParams = new GetViewColumnOptions(type)
        var column = actionView.getViewColumn(columnParams)
        if (column && value) {
            if (whereClause.length > 0)
                whereClause += " AND "
            whereClause += "([" + column.name + "] like '" + value + "')"
        }
        return whereClause
    }

    getActions(request) {
        this.refreshFilters()

        this.$scope.$root.$broadcast('disableLoadingIndicator')

        var actionRequest = new GridRequestModel();
        actionRequest.columns = this.$scope.columns
        actionRequest.pageNumber = 1
        actionRequest.pageSize = this.pageSize

        var dateFormat = window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')

        var fromDate = moment(this.selectedFilters.selectedFromDate, dateFormat).format('YYYY-MM-DD HH:mm')
        var toDate = moment(this.selectedFilters.selectedToDate, dateFormat).format('YYYY-MM-DD HH:mm')
        var idType = this.selectedFilters.selectedType ? this.selectedFilters.selectedType.id : null
        var idState = this.selectedFilters.selectedState ? this.selectedFilters.selectedState.id : null
        var idOperator = this.selectedFilters.selectedOperator ? this.selectedFilters.selectedOperator.id : null
        var idDevice = this.selectedFilters.selectedDevice ? this.selectedFilters.selectedDevice.id : null
        var idLocation = this.selectedFilters.selectedLocation ? this.selectedFilters.selectedLocation.id : null
        var idMeter = this.selectedFilters.selectedMeter ? this.selectedFilters.selectedMeter.id : null
        var idModule = this.selectedFilters.selectedModule ? this.selectedFilters.selectedModule.id : null

        this.saveDatesToLocalStorage()

        var actionView = this.localDictionary.getActiveView(CommonHelper.IdAction)
        var whereClause = ''
        if (actionView) {
            if (actionRequest.columns.length == 0) {
                actionRequest.columns = actionView.columns.map(c => {
                    var column = new ColumnModel()
                    column.id = c.idDataType
                    column.name = c.name
                    return column
                })
            }
            var columnParams = new GetViewColumnOptions(DataType.HELPER_CREATION_DATE)
            var column = actionView.getViewColumn(columnParams)
            if (column && fromDate && toDate) {
                whereClause += "([" + column.name + "] >= '" + fromDate + "' AND "
                whereClause += "[" + column.name + "] <= '" + toDate + "')"
            }

            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_ID_ACTION_TYPE, idType)
            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_ID_ACTION_STATUS, idState)
            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_ID_OPERATOR, idOperator)
            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_SERIAL_NBR, idDevice)
            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_ID_LOCATION, idLocation)
            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_ID_METER, idMeter)
            whereClause = this.addValueToWhereClause(actionView, whereClause, DataType.HELPER_ID_MODULE, idModule)
        }

        if (!actionRequest.where) actionRequest.where = ''

        if (actionRequest.where.length) {
            actionRequest.where = actionRequest.where + " and "
        }
        actionRequest.where = actionRequest.where + whereClause

        if (this.$state.params['ids'] && this.$state.params['ids'].length > 0) {
            var primaryColumn = this.localDictionary.getPrimaryKeyColumn(CommonHelper.IdAction)
            if (primaryColumn) {
                var fColumns = actionRequest.columns.filter(c => {
                    if (primaryColumn.idDataType == c.id) {
                        return true
                    }
                    return false
                })
                var where = '[' + primaryColumn.name + '] in (' + this.$state.params['ids'].join(',') + ')'
                if (fColumns.length > 0) {
                    var fColumn = fColumns[0]

                    if (!fColumn.where) fColumn.where = [where]
                    else fColumn.where.push(where)
                } else {
                    var fColumn = new ColumnModel()
                    fColumn.name = primaryColumn.name
                    fColumn.id = primaryColumn.idDataType
                    fColumn.where = [where]
                }

                if (actionRequest.where.length) {
                    actionRequest.where = actionRequest.where + " and "
                }
                actionRequest.where = actionRequest.where + where
            }
        }

        return this.api.actions.getActions(actionRequest, this.requestState).then(result => {
            this.$scope.showArrow = true

            this.$scope.$root.$broadcast('enableLoadingIndicator')
            if (result && result.values) {
                if (result.totalCount > this.pageSize) {
                    CommonHelper.openInfoPopup(i18n('Grid', 'FoundTooManyRecords').replace('{0}', result.totalCount).replace('{1}', this.pageSize), 'info', 4000)
                }

                for (var i = result.values.length - 1; i >= 0; i--) {
                    var val = result.values[i]
                    if (val['act_10123_0']) {
                        val.parentId = val['act_10123_0']
                    } else {
                        val.parentId = 0
                    }
                }
            }
            this.$scope.showGrid = true
            this.$scope.$broadcast(EventsNames.DISABLE_CANCEL_BUTTON)
            return result
        })
    }

    getActionsWithTreeListRefresh() {
        this.treeList.beginCustomLoading(i18n('Grid', 'Loading'))
        this.getActions(null).then(result => {
            this.$scope.$root.$broadcast(EventsNames.UPDATE_GRID_DATASOURCE + this.treeListId, new DataSource(result.values))
            this.treeList.endCustomLoading()
        })
    }

    clearActionFilter(filterName: string, type: string) {
        this.selectedFilters[filterName] = null
        OperatorLayoutSettings.setSetting(type, null)
        this.getActionsWithTreeListRefresh()
        this.$scope.$broadcast(EventsNames.ACTION_FILTER_UPDATED, this.selectedFilters)
    }

    refreshFilters() {
        var additionalFilters = []

        var dateFormat = window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')

        this.pushToAdditionalFiltersIfExists(additionalFilters, 10058, [moment(this.selectedFilters.selectedFromDate, dateFormat).format(dateFormat), moment(this.selectedFilters.selectedToDate, dateFormat).format(dateFormat)], ['>= ', '<= '], null, ' AND ', () => {
            this.resetDate()
            this.refreshFilters()
            CommonHelper.openInfoPopup(i18n('Common', 'SetUpDefaultDateRange'), 'info', 3000)
            this.getActionsWithTreeListRefresh()
            this.$scope.$broadcast(EventsNames.ACTION_FILTER_UPDATED, this.selectedFilters)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, 10120, this.selectedFilters.selectedType, '= ', () => {
            this.clearActionFilter('selectedType', OperatorLayoutSettings.ActionType)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, 10121, this.selectedFilters.selectedState, '= ', () => {
            this.clearActionFilter('selectedState', OperatorLayoutSettings.ActionState)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, 10002, this.selectedFilters.selectedLocation, '= ', () => {
            this.clearActionFilter('selectedLocation', OperatorLayoutSettings.ActionLocationId)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, 10004, this.selectedFilters.selectedDevice, '= ', () => {
            this.clearActionFilter('selectedDevice', OperatorLayoutSettings.ActionDeviceId)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, 10003, this.selectedFilters.selectedMeter, '= ', () => {
            this.clearActionFilter('selectedMeter', OperatorLayoutSettings.ActionMeterId)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, 10032, this.selectedFilters.selectedOperator, '= ', () => {
            this.clearActionFilter('selectedOperator', OperatorLayoutSettings.ActionOperator)
        })
        this.pushToAdditionalFiltersIfExists(additionalFilters, 10124, this.selectedFilters.selectedModule, '= ', () => {
            this.clearActionFilter('selectedModule', OperatorLayoutSettings.ActionModule)
        })

        if (this.$scope.mainTreeListOptions)
            this.$scope.mainTreeListOptions.additionalFilters = additionalFilters
    }

    pushToAdditionalFiltersIfExists(additionalFilters: any[], columnId: number, selectedValue: any, condition: any, clearFilter = null, separator: string = null, catchClearFilter = null) {
        if (!selectedValue || !additionalFilters) return
        var column = _.find(this.$scope.columns, col => col.id == columnId)
        if (column) {
            if (angular.isArray(selectedValue) && angular.isArray(condition)) {
                var additionalFilter: any = []
                for (var i in selectedValue) {
                    additionalFilter.push({
                        columnName: column.caption + ' [CUSTOM_ICON=FILTERS]',
                        condition: condition[i] + (selectedValue[i].caption || selectedValue[i])
                    })
                }
                additionalFilter.separator = separator
                additionalFilter.clearFilter = clearFilter
                additionalFilter.catchClearFilter = catchClearFilter
                additionalFilters.push(additionalFilter)
            } else {
                additionalFilters.push({
                    columnName: column.caption + ' [CUSTOM_ICON=FILTERS]',
                    condition: condition + (selectedValue.caption || selectedValue),
                    clearFilter: clearFilter
                })
            }
        }
    }

    resetDate() {
        var dateFormat = window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS')
        var date = new Date()
        date.setHours(0, 0, 0, 0)
        var fromDate = moment(date.setDate(new Date().getDate() - 6))
        this.selectedFilters.selectedFromDate = fromDate.format(dateFormat)

        date = new Date()
        date.setHours(23, 59, 59, 999)
        var toDate = moment(date)
        this.selectedFilters.selectedToDate = toDate.format(dateFormat)

        this.saveDatesToLocalStorage()
    }

    saveDatesToLocalStorage() {
        OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionFromDate, this.selectedFilters.selectedFromDate)
        OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ActionToDate, this.selectedFilters.selectedToDate)
    }

    drawGrid() {
        this.localDictionary.getActionColumns().then(columns => {
            _.map(columns, col => {
                if (col.type == CommonHelper.datetime)
                    col.type = CommonHelper.date
            })
            var defColExist = false
            this.localDictionary.getActionDefaultColumns().then(defaultColumns => {
                _.map(defaultColumns, defCol => {
                    if (defCol.type == CommonHelper.datetime)
                        defCol.type = CommonHelper.date
                })

                // Check if in defaultColumns are columns which are not in columnsDictionary
                defaultColumns.forEach(dColumn => {
                    defColExist = false
                    columns.forEach(Column => {
                        if (dColumn.id == Column.id) {
                            defColExist = true
                        }
                    })
                    if (defColExist == false) {
                        columns.push(dColumn)
                    }
                })

                this.$scope.defaultColumns = defaultColumns
                this.$scope.columns = columns

                Permissions.hasPermissions([Permissions.ACTION_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED]).then(columnsReorderingDisabled => {
                    this.getActions(null).then((result) => {
                        this.$scope.mainTreeListOptions = {
                            referenceId: CommonHelper.IdAction,
                            idReferenceType: Enums.ReferenceType.IdAction,
                            name: 'ActionsTreeList',
                            type: GridTypes.MAIN,
                            keyExpr: 'id',
                            parentIdExpr: 'parentId',
                            defaultColumnsDictionary: defaultColumns,
                            columnsDictionary: columns,
                            addCustomFilters: true,
                            allowColumnReordering: !columnsReorderingDisabled,
                            onInitialized: e => {
                                this.treeListId = e.tableId
                                this.treeList = e.component
                            },
                            onNodesInitialized: e => {
                                if (this.treeList) {
                                    e.root.children.forEach(child => {
                                        this.treeList.collapseRow(child.key)
                                    })
                                }
                            },
                            onContentReady: e => {
                                if (this.$state.params['ids'] && this.$state.params['ids'].length > 0 && this.$state.params['ids'].length > e.component.totalCount()) {

                                    this.$timeout(() => {
                                        this.openChangeFiltersToast()

                                        this.$scope.filtersInfoPopover.show('#actionFilters' + this.treeListId)

                                        this.$timeout(() => {
                                            this.$scope.filtersInfoPopover.hide()
                                        }, 10000)
                                    })
                                }
                            },
                            dataSource: new DataSource(result.values),
                            onRowDoubleClick: e => {
                                this.$scope.showDetails(e)
                            },
                            buttonsOptions: {
                                enabled: true,
                                showDetailsPermissions: "['" + Permissions.ACTION_LIST + "']",
                                deletePermissions: "['" + Permissions.ACTION_DEL + "']",
                                saveColumnSettingsPermissions: "['" + Permissions.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP + "']",
                                onShowClick: () => {
                                    this.$scope.showDetails({ data: this.treeList.getSelectedRowsData()[0] })
                                },
                                onShowFilters: () => {

                                }
                            },
                            localStorageVarForSavedEntity: "actionSaved"
                        }

                        this.$timeout(() => {
                            this.refreshFilters()
                        })
                    })
                })
            })
        })
    }

    private mockGetActionMethodAndRefreshGrid() {
        // Store standard getAction method
        var currentGetActions = this.getActions

        // mock getAction method
        this.getActions = (request) => {
            return this.$q.resolve({}) as any
        }

        // refresh grid with mocked method to get actions
        this.getActionsWithTreeListRefresh()

        // restore getActions method
        this.getActions = currentGetActions
    }


    //#region Toast

    private changeFiltersToast: IIMRToast

    private openChangeFiltersToast(): void {
        if (this.changeFiltersToast == null) {
            this.changeFiltersToast = ToastHelper.showWarning(
                LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ChangeDateRange), {
                onHidden: (e: IMRToastHiddenArgs) => {
                    this.changeFiltersToast = null
                }
            })
        }
    }

    //#endregion

}

